import React, { useState, useEffect } from "react";
import config from "../../config";
import axios from "axios";
import {
  Table,
  message,
  Form,
  Input,
  DatePicker,
  Select,
  Pagination,
  Tooltip,
  Checkbox,
  Card,
  Row,
  Col,
  Statistic,
  Spin,
  Typography,
} from "antd";
import {
  DeleteOutlined,
  IdcardOutlined,
  EditOutlined,
  FileOutlined,
} from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import dayjs from "dayjs";
import moment from "moment";
import { calculateColumnTotal } from "../../components/Shared/Utility";
import { NumberFormat } from "../../components/Shared/Utility";

const PumpSubscriptions = () => {
  const [loading, setLoading] = useState(false);
  const UserID = localStorage.getItem("AdminID");
  const AccessKey = localStorage.getItem("AdminAccessKey");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [Package, setPackage] = useState("");
  const [PumpCode, setPumpCode] = useState("");
  const [Email, setEmail] = useState("");
  const [Mobile, setMobile] = useState("");
  const [listOfLedger, setListOfLedger] = useState([]);
  const [ListOfPackages, setListOfPackages] = useState([]);
  const [HideZeroBalance, setHideZeroBalance] = useState(false);
  const [orderby, SetOrderBy] = useState("");

  // pagination
  const [PageNo, setPageNo] = useState(1);
  const [PageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [ListofSubscriptionWithTotal, SetListofSubscriptionWithTotal] =
    useState([]);
  const [dashboard, setDashboard] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(false);

  useEffect(() => {
    setDashboardLoading(true);
    const dashPayload = {
      UserID: UserID,
      AccessKey: AccessKey,
      HideZeroBalance: HideZeroBalance,
    };
    axios({
      method: "post",
      url: config.base_url + "AdminUser/GetSubscriptionDashboardMetrics",
      headers: {
        "Content-Type": "application/json",
      },
      data: dashPayload,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setDashboard(response.data);
        } else {
          setDashboard(null);
        }
        setDashboardLoading(false);
      })
      .catch(function () {
        message.error("Could not load subscription dashboard");
        setDashboardLoading(false);
      });
  }, [UserID, AccessKey, HideZeroBalance]);

  useEffect(() => {
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      startDate: startDate,
      endDate: endDate,
      PageNo: PageNo,
      PageSize: PageSize,
      PackageID: Package,
      PumpCode: PumpCode,
      Email: Email,
      PaymentMode: Mobile,
      HideZeroBalance: HideZeroBalance,
      SortBy: orderby,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "AdminUser/GetAllPurchases",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setListOfLedger(response.data.listofRecords);
          setTotalRecords(response.data.totalRecords);

          setLoading(false);
        } else {
          // Handle error
          setLoading(false);
        }
        //   setLoading(false);
      })
      .catch(function (error) {
        message.error("Network Error");
        console.log(error);
      });
  }, [startDate, endDate, Package, PumpCode, Email, Mobile, PageSize, PageNo, HideZeroBalance, orderby]);

  useEffect(() => {
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "AdminUser/GetPackagesList",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
       
        if (response.data.status_code == 1) {
          setListOfPackages(
            response.data.ListofRecords.map((item) => ({
              value: item.ID,
              label: item.Name,
            }))
          );

          setLoading(false);
        } else {
          // Handle error
          setLoading(false);
        }
        //   setLoading(false);
      })
      .catch(function (error) {
        message.error("Network Error");
        console.log(error);
      });
  }, []);

  const handleTableChange = async (pagination, filters, sorter) => {
    const sortField = sorter.field;
    const sortOrder = sorter.order === "ascend" ? "asc" : "desc"; 
  
    // Handling sorting for StartDate
    if (sortField === "StartDate") {
      if (sortOrder === "asc") {
        SetOrderBy("StartDate Asc");
      } else {
        SetOrderBy("StartDate Desc");
      }
    } 
    // Handling sorting for EndDate
    else if (sortField === "EndDate") {
      if (sortOrder === "asc") {
        SetOrderBy("EndDate Asc");
      } else {
        SetOrderBy("EndDate Desc");
      }
    }
  };


  // Package Asc
  // Package Dsc
  

  useEffect(() => {
    const totalsRow = {
      ID: null,
      PumpCode: null,
      Created_Date: "",
      EndDate: "",
      PackageName: "",
      PaymentMode: "",
      PaymentReceivedBy: "Total",
      PackagePrice: calculateColumnTotal(listOfLedger, "PackagePrice"),
      DiscountPercentage: null,
      DiscountValue: calculateColumnTotal(listOfLedger, "DiscountValue"),
      NetReceiveable: calculateColumnTotal(listOfLedger, "NetReceiveable"),
      GracePeriod: null,
    };
    // {calculateColumnTotal(
    //   paymentReceived,
    //   "Amount"
    // )}

    let newlist = [...listOfLedger, totalsRow];
    SetListofSubscriptionWithTotal(newlist);
  }, [listOfLedger]);

  const columns = [
    // {
    //   title: "SR#",
    //   dataIndex: "Sr",
    //   key: "Sr",
    //   render: (_, record, index) => index + 1 + PageSize * (PageNo - 1),
    // },
    {
      title: "ID",
      dataIndex: "ID",
      key: "ID",
    },
    {
      title: "Pump Code",
      dataIndex: "PumpCode",
      key: "PumpCode",
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name"
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email"
    },
    {
      title: "Start Date",
      dataIndex: "StartDate",
      key: "startdate",
      sorter: true,
      render: (_, record) =>
        record.ID != null
          ? dayjs(record.StartDate).format(config.date_format)
          : "",
    },
    {
      title: "End Date",
      dataIndex: "EndDate",
      key: "enddate",
      sorter:true,
      render: (_, record) =>
        record.ID != null
          ? dayjs(record.EndDate).format(config.date_format)
          : "",
    },

    {
      title: "Package",
      dataIndex: "PackageName",
      key: "PackageName",
    },

    {
      title: "Payment Mode",
      dataIndex: "PaymentMode",
      key: "PaymentMode",
    },
    {
      title: "Payment Received By",
      dataIndex: "PaymentReceivedBy",
      key: "PaymentReceivedBy",
      render: (_, record) =>
        record.ID != null ? (
          <span>
            {record.PaymentReceivedBy || "-"}
            {record.UserID > 0 ? (
              <span style={{ color: "#64748b", fontSize: 11 }}> (#{record.UserID})</span>
            ) : null}
          </span>
        ) : (
          record.PaymentReceivedBy
        ),
    },
    {
      title: "Price",
      dataIndex: "PackagePrice",
      key: "PackagePrice",
      align:"right",
      render: (_, record) =>
        record.ID != null ? (
          NumberFormat(record.PackagePrice, 0)
        ) : (
          <strong>{NumberFormat(record.PackagePrice, 0)}</strong>
        ),
    },
    {
      title: "Discount %",
      dataIndex: "DiscountPercentage",
      key: "DiscountPercentage",
      align:"right",
    },
    {
      title: "Discount Value",
      dataIndex: "DiscountValue",
      key: "DiscountValue",
      align:"right",
      render: (_, record) =>
        record.ID != null ? (
          NumberFormat(record.DiscountValue, 0)
        ) : (
          <strong>{NumberFormat(record.DiscountValue, 0)}</strong>
        ),
    },
    {
      title: "Net Receiveable",
      dataIndex: "NetReceiveable",
      key: "NetReceiveable",
      align:"right",
      render: (_, record) =>
        record.ID != null ? (
          NumberFormat(record.NetReceiveable, 0)
        ) : (
          <strong>{NumberFormat(record.NetReceiveable, 0)}</strong>
        ),
    },

    {
      title: "Grace Period",
      dataIndex: "GracePeriod",
      key: "GracePeriod",
      align:"right",
    },
    {
      title: "Created Date",
      dataIndex: "Created_Date",
      key: "created_date",
      sorter:true,
      render: (_, record) =>
        record.ID != null
          ? dayjs(record.Created_Date).format(config.date_format)
          : "",
    },
    {
      title: "Action",
      key: "Action",
      fixed: "right",
      width: 100,
      render: (_, record) => 
        record.ID !=null ? 
          <div style={{ textAlign: "center", display: "flex", gap: 10 }}>
            <Tooltip title="Suspend">
              <DeleteOutlined />
            </Tooltip>
            <Tooltip title="View Detils">
              <NavLink to={`/controlbase/petrolpump/detail/${record.PumpID}`}>
                <IdcardOutlined />
              </NavLink>
            </Tooltip>
            <Tooltip title="Update Subscription">
              <NavLink
                to={`/controlbase/petrolpump/edit-subscription/${record.ID}`}
              >
                <EditOutlined />
              </NavLink>
            </Tooltip>
            <Tooltip title="Subscription Invoice">
              <NavLink
                to={`/controlbase/fuelbook/subscription-invouce-pdf/${record.ID}`}
              >
                <FileOutlined />
              </NavLink>
            </Tooltip>
          </div>
        :''
        
      },
    
  ];

  const { RangePicker } = DatePicker;
  const handleDateChange = (date, value) => {
    setStartDate(value[0]);
    setEndDate(value[1]);
  };
  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };
  const handleSearchByCode = (e) => {
    setPumpCode(e.target.value);
  };

  const handleSearchByEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleSearchByMobile = (e) => {
    setMobile(e.target.value);
  };

  const onPageChange = (page, pageSize) => {
    setPageNo(page);
  };

  const onPageSizeChange = (current, size) => {
    setPageNo(1);
    setPageSize(size);
  };

  const expiringColumns = [
    {
      title: "Pump Code",
      dataIndex: "PumpCode",
      key: "PumpCode",
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
    },
    {
      title: "Mobile",
      dataIndex: "Mobile",
      key: "Mobile",
    },
    {
      title: "Package",
      dataIndex: "PackageName",
      key: "PackageName",
    },
    {
      title: "End Date",
      dataIndex: "EndDate",
      key: "EndDate",
      render: (v) => (v ? dayjs(v).format(config.date_format) : ""),
    },
    {
      title: "Days left",
      dataIndex: "DaysUntilExpiry",
      key: "DaysUntilExpiry",
      align: "right",
    },
    {
      title: "Net (renewal)",
      dataIndex: "NetReceiveable",
      key: "NetReceiveable",
      align: "right",
      render: (v) => NumberFormat(v, 0),
    },
  ];

  const forecastColumns = [
    {
      title: "Month",
      dataIndex: "MonthLabel",
      key: "MonthLabel",
    },
    {
      title: "Est. renewal revenue",
      dataIndex: "EstimatedRenewalRevenue",
      key: "EstimatedRenewalRevenue",
      align: "right",
      render: (v) => NumberFormat(v, 0),
    },
  ];

  const counts = dashboard?.subscriptionCounts;

  return (
    <>
      <div className="right-side-contents">
        <div className="page-content control-base-wrap">
          <div className="page-header">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
              <h3 className="page-title mb-0">Subscriptions</h3>
              <NavLink to="/controlbase/petrolpump/assign-payment-received-by">
                Assign Payment Received By
              </NavLink>
            </div>
          </div>

          <Spin spinning={dashboardLoading}>
            {counts && (
              <>
                <Typography.Title level={5} style={{ marginTop: 0 }}>
                  Active subscriptions by type
                </Typography.Title>
                <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
                  <Col xs={12} sm={8} md={4}>
                    <Card size="small">
                      <Statistic title="Trial" value={counts.Trial} />
                    </Card>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <Card size="small">
                      <Statistic title="Monthly" value={counts.Monthly} />
                    </Card>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <Card size="small">
                      <Statistic title="6 Month" value={counts.SixMonth} />
                    </Card>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <Card size="small">
                      <Statistic title="Yearly" value={counts.Yearly} />
                    </Card>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <Card size="small">
                      <Statistic title="Cloud fee" value={counts.CloudFee} />
                    </Card>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <Card size="small">
                      <Statistic title="Lifetime" value={counts.Lifetime} />
                    </Card>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <Card size="small">
                      <Statistic title="Other / unmapped" value={counts.Other} />
                    </Card>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <Card size="small">
                      <Statistic title="Total rows" value={counts.Total} />
                    </Card>
                  </Col>
                </Row>

                <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                  <Col xs={24} lg={12}>
                    <Card size="small" title="Estimated renewal revenue by month">
                      <Typography.Text
                        type="secondary"
                        style={{ display: "block", marginBottom: 12 }}
                      >
                        Sum of Net Receiveable for subscriptions whose end date falls in each
                        calendar month (next 6 months).
                      </Typography.Text>
                      <Table
                        size="small"
                        pagination={false}
                        rowKey={(r) => `${r.Year}-${r.Month}`}
                        dataSource={dashboard.monthlyRenewalForecast || []}
                        columns={forecastColumns}
                      />
                    </Card>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Card
                      size="small"
                      title={`Expiring within ${dashboard.expiringWithinDays ?? 30} days`}
                    >
                      <Typography.Text
                        type="secondary"
                        style={{ display: "block", marginBottom: 12 }}
                      >
                        Contacts for renewal reminders before subscription end.
                      </Typography.Text>
                      <Table
                        size="small"
                        scroll={{ x: "max-content" }}
                        pagination={
                          (dashboard.expiringSubscriptions || []).length > 12
                            ? { pageSize: 12 }
                            : false
                        }
                        rowKey={(r, i) =>
                          `${r.PumpCode}-${r.EndDate}-${i}`
                        }
                        dataSource={dashboard.expiringSubscriptions || []}
                        columns={expiringColumns}
                      />
                    </Card>
                  </Col>
                </Row>
              </>
            )}
          </Spin>

          <div className="filters-wrap">
            <Form>
              <Form.Item>
                <RangePicker
                  allowClear
                  onChange={handleDateChange}
                  disabledDate={disabledDate}
                />
              </Form.Item>
              <Form.Item>
                <Select
                  allowClear
                  showSearch
                  style={{
                    width: "200px",
                  }}
                  placeholder="Packge"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => setPackage(value)}
                  options={ListOfPackages}
                />
              </Form.Item>
              <Form.Item>
                <Input
                  allowClear
                  showSearch
                  placeholder="Pump Code"
                  value={PumpCode}
                  onChange={handleSearchByCode}
                />
              </Form.Item>
              <Form.Item>
                <Input
                  allowClear
                  showSearch
                  placeholder="Search By Email"
                  value={Email}
                  onChange={handleSearchByEmail}
                />
              </Form.Item>
              <Form.Item>
                <Input
                  allowClear
                  showSearch
                  placeholder="Payment Mode"
                  value={Mobile}
                  onChange={handleSearchByMobile}
                />
              </Form.Item>
              <Form.Item>
                <Checkbox onClick={() => setHideZeroBalance((prev) => !prev)}>
                  Hide Trial Accounts
                </Checkbox>
              </Form.Item>
            </Form>
          </div>
          <Table
            size="small"
            scroll={{
              x: "max-content",
            }}
            loading={loading}
            // dataSource={listOfLedger}
            dataSource={ListofSubscriptionWithTotal}
            columns={columns}
            onChange={handleTableChange}
            pagination={false}
            bordered
          />
          <div className="text-end mt-5">
            <Pagination
              current={PageNo}
              pageSize={PageSize}
              size="small"
              total={totalRecords}
              onChange={onPageChange}
              onShowSizeChange={onPageSizeChange} // Handle page size change
              showSizeChanger
              showQuickJumper
              showTotal={(total) => `Total ${total} items`}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PumpSubscriptions;
